import React from "react";
import { usePageLoading } from "../utility/loadingBar";
import CachedPreview, { cachedPreviewFor } from "./CachedPreview";
import "./PortalSkeleton.css";

// The account and office pages' layout (logo bar, menu, page) in grey while
// the person's profile and the page's file load, instead of a spinner on an
// empty screen. Nothing in it reads data: the real menu and page replace it
// as soon as they can draw. App.js shows it while sign-in and the profile
// load, and utility/lazyPage's fallback while a screen downloads.
export const isPortalPath = (path) => /^\/(account|office)(\/|$)/.test(path || "") && !/^\/account\/print\//.test(path || "");

const collapsedMenu = () => {
  try {
    return window.localStorage.getItem("sidebarCollapse") === "true" && window.innerWidth >= 768;
  } catch (e) {
    return false;
  }
};

const PortalSkeleton = () => {
  // The portal's loading bar runs while it is shown (utility/loadingBar).
  usePageLoading(true);
  const narrow = collapsedMenu();
  // Orders, Quotes and Invoices: the last version this browser has, grey, in
  // place of the grey bars of the page.
  const preview = cachedPreviewFor(window.location.pathname);
  return (
    <div className="pskel" data-skeleton="portal" aria-busy="true" aria-label="Loading">
      <div className="pskelTop">
        <img src={require("../assets/logo.png")} alt="" className="pskelLogo" />
        <span className="pskelBar pskelAvatar" />
      </div>
      <div className="pskelBody">
        <div className={`pskelMenu ${narrow ? "isNarrow" : ""}`}>
          {[0, 1, 2, 3, 4, 5].map((i) => <span key={i} className="pskelBar pskelItem" />)}
        </div>
        <div className="pskelMain">
          {preview ? <CachedPreview preview={preview} /> : (
            <>
              <span className="pskelBar pskelTitle" />
              <div className="pskelCard">
                {[0, 1, 2, 3, 4].map((i) => <span key={i} className="pskelBar pskelLine" style={{ width: `${92 - i * 9}%` }} />)}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortalSkeleton;
